'use strict';

angular.module('adelementAdminApp')
	.controller('NotificationsDeleteController', function($scope, $uibModalInstance, entity, Notifications) {

        $scope.notifications = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            Notifications.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });
